import { buildApiUrl, serverFetch } from "@core/server";

export function fetchSprNumberPriceList() {
  return serverFetch("sprs/number-price");
}

export function fetchSprNumberPrice(id) {
  return serverFetch(`sprs/number-price/${id}`);
}

export function createSprNumberPrice(bodyData) {
  return serverFetch("sprs/number-price", {
    method: "POST",
    bodyData
  });
}

export function saveSprNumberPrice(bodyData) {
  return serverFetch("sprs/number-price", {
    method: "PUT",
    bodyData
  });
}

export function deleteSprNumberPrice(id) {
  return serverFetch(`sprs/number-price/${id}`, {
    method: "DELETE"
  });
}

export function copySprNumberPrice(id) {
  return serverFetch(`sprs/number-price/${id}/copy`, {
    method: "POST"
  });
}

export function fetchSprNumberPriceUslList(id) {
  return serverFetch(`sprs/number-price/${id}/usl`);
}

export function fetchSprNumberPriceUsl(id, idStr) {
  return serverFetch(`sprs/number-price/${id}/usl/${idStr}`);
}

export function createSprNumberPriceUsl(id, bodyData) {
  return serverFetch(`sprs/number-price/${id}/usl`, {
    method: "POST",
    bodyData
  });
}

export function saveSprNumberPriceUsl(id, bodyData) {
  return serverFetch(`sprs/number-price/${id}/usl`, {
    method: "PUT",
    bodyData
  });
}

export function deleteSprNumberPriceUsl(id, idStr) {
  return serverFetch(`sprs/number-price/${id}/usl/${idStr}`, {
    method: "DELETE"
  });
}

export function copySprNumberPriceUsl(id, idStr) {
  return serverFetch(`sprs/number-price/${id}/usl/${idStr}/copy`, {
    method: "POST"
  });
}

export function fetchSprNumberPricePrim(id, idStr, vid) {
  return serverFetch(`sprs/number-price/${id}/usl/${idStr}/prim`, {
    queryParams: vid != null ? { vid } : undefined
  });
}

export function fetchSprNumberPricePrimAll(id) {
  return serverFetch(`sprs/number-price/${id}/prim`);
}

export function replaceSprNumberPricePrim(id, idStr, bodyData) {
  return serverFetch(`sprs/number-price/${id}/usl/${idStr}/prim`, {
    method: "PUT",
    bodyData
  });
}

export async function exportSprNumberPriceXml(id) {
  const url = buildApiUrl(`sprs/number-price/${id}/xml`);
  const headers = new Headers({ Accept: "application/xml" });
  const sessionId = localStorage.getItem("sessionId");
  if (sessionId) headers.append("sessionId", sessionId);

  const response = await fetch(url, {
    method: "GET",
    credentials: "include",
    headers
  });

  if (!response.ok) {
    let message = "Не удалось экспортировать";
    try {
      const contentType = response.headers.get("content-type") || "";
      if (contentType.includes("application/json")) {
        const json = await response.json();
        message = json?.message || message;
      } else {
        const text = await response.text();
        if (text) message = text;
      }
    } catch {
      /* ignore */
    }
    throw new Error(message);
  }

  const blob = await response.blob();
  let fileName = `price-${id}.xml`;
  const disposition = response.headers.get("content-disposition") || "";
  const match =
    /filename\*=UTF-8''([^;]+)|filename="([^"]+)"|filename=([^;]+)/i.exec(disposition);
  if (match) {
    fileName = decodeURIComponent((match[1] || match[2] || match[3] || "").trim());
  }

  return { blob, fileName };
}

export function importSprNumberPriceXml(id, xml) {
  return serverFetch(`sprs/number-price/${id}/xml`, {
    method: "POST",
    bodyData: { xml }
  });
}
